export const ProductLineStorageKey = 'gender-productline';
